module.exports = __webpack_public_path__ + "img/sld_up_arrow.b43b0f90.svg";